"use client"
import {Breadcrumb, BreadcrumbItem, BreadcrumbList} from "@/components/ui/breadcrumb";
import {cn} from "@/lib/utils";
import Link from "next/link";
import {BreadcrumbComponentProps, categoryDataProps} from "@/interface/components/breadcrumb";
import {StaticText} from "@/constants/static-data";


export function BreadcrumbComponent({
                                        categoryData,
                                        isBrand = false,
                                        brand,
                                        isSearch = false,
                                        searchParams
                                    }: BreadcrumbComponentProps) {
    return (
        <Breadcrumb className={`mt-10 px-5 md:mt-0`}>

            <BreadcrumbList
                className={cn("w-full my-1 md:my-10 md:mb-0 flex flex-wrap text-xs rounded list-none last:border-none")}>
                <BreadcrumbItem>
                    <Link href="/"
                          className={cn("pl-4 border-l text-gray-500 font-medium hover:text-orange-600")}>
                        {StaticText.Elanza}
                    </Link>
                </BreadcrumbItem>
                {isSearch ? (
                    <div className={"flex gap-x-1 items-center"}>{StaticText.searchFor}
                        <p className={"font-semibold text-sm"}>{searchParams?.search}</p></div>
                ) : (
                    <>
                        {isBrand ? (
                            <Link className={" text-gray-500 hover:text-orange-600 font-medium transition-all"}
                                  href={`/brand/${brand?.slug}`}>{brand?.title}</Link>
                        ) : (
                            <>
                                {Object.values(categoryData || [])?.map((item: categoryDataProps, index: number) => (
                                    <div
                                        key={index}
                                        className={cn("flex items-center", {
                                            "border-l pl-2": index !== Object.values(categoryData || []).length - 1,
                                        })}>
                                        <BreadcrumbItem>
                                            <Link
                                                href={`/category/${item?.slug}`}
                                                className={cn(" text-gray-500 hover:text-orange-600 font-medium")}>
                                                {item?.title}
                                            </Link>
                                        </BreadcrumbItem>
                                    </div>
                                ))}
                            </>
                        )}</>
                )}

            </BreadcrumbList>
        </Breadcrumb>
    );
}
